export default __webpack_public_path__ + "static/media/My_information.02e7b04a.pdf";